import React from 'react'

import { ButtonProps, makeAppStyles, MenuAbstractionProps, MenuOption, RoundedPlainTextButtonMenu } from '@percept/mui'

import { PerformanceTimeseriesPreset } from './lib'
import { ArrowDropDown } from '@material-ui/icons'


export type PerformanceTimeseriesPresetLabels = Record<PerformanceTimeseriesPreset, string>

// const optionValueOrder: PerformanceTimeseriesPreset[] = [
//   'last-week',
//   'last-month',
//   'last-quarter',
// ]

const optionValueOrder: PerformanceTimeseriesPreset[] = [
  '1-day',
  '7-days',
  '30-days',
  'this-month',
  'this-quarter',
  'this-year',
]

const defaultLabeLs: PerformanceTimeseriesPresetLabels = {
  '1-day': '1 Day',
  '7-days': '7 Days',
  '30-days': '30 Days',
  'this-month': 'This Month',
  'this-quarter': 'This Quarter',
  'this-year': 'This Year',
}



export type TimeRangeSelectProps = {
  value: PerformanceTimeseriesPreset
  labels?: PerformanceTimeseriesPresetLabels
  onChange: (value: PerformanceTimeseriesPreset) => void
} & Partial<Omit<MenuAbstractionProps<ButtonProps>, 'value' | 'onChange' | 'children'>>

const useStyles = makeAppStyles( theme => ({
  button: {
    height: 22,
  }
}))

export const TimeRangeSelect = ({
  value,
  onChange,
  labels = defaultLabeLs,
  TriggerProps,
  ...props
}: TimeRangeSelectProps) => {
  // const classes = useStyles()
  const options: MenuOption<PerformanceTimeseriesPreset>[] = optionValueOrder.map( value => ({
    value,
    label: labels[value],
  }))
  return (
    <RoundedPlainTextButtonMenu
      {...props}
      TriggerProps={{
        size: 'small',
        variant: 'contained',
        endIcon: <ArrowDropDown />,
        ...(TriggerProps || {}),
        // classes: {
        //   root: classes.button,
        // }
      }}
      value={value}
      label={labels[value]}
      options={options}
      onChange={(_, value): void => onChange(value)} />
  )
}
